import { useTranslation } from 'react-i18next'
import DETECTOR from 'url:../assets/images/detector.webp'
import VEST from 'url:../assets/images/vest.webp'

/** Photos are pre-cropped square at 3× their display size, so they stay sharp on retina */
const ITEMS = [
  { src: DETECTOR, caption: 'droneDetectorDescription' },
  { src: VEST, caption: 'vestDescription' },
]

export default function Equipment() {
  const { t } = useTranslation()

  return (
    <section className='w-full px-4 md:max-w-xl grid grid-cols-1 sm:grid-cols-2 gap-6'>
      {ITEMS.map(({ src, caption }) => (
        <figure key={caption} className='flex flex-col items-center gap-2'>
          {/* The caption already describes the photo, so the image is decorative */}
          <img
            src={src}
            alt=''
            loading='lazy'
            className='aspect-square w-40 rounded-sm object-cover'
          />
          <figcaption className='text-sm text-gray-300'>{t(caption)}</figcaption>
        </figure>
      ))}
    </section>
  )
}
